export default import.meta.ROLLDOWN_FILE_URL_OPgqXnrjQmfLF9Ge9Zf_SQ